import { NgOptimizedImage } from '@angular/common';
import { seasonClass } from '@aston/foundation';
import { RouterOutlet } from '@angular/router';
import { Component, inject } from '@angular/core';

import { AppConfiguration } from '../../../app.configuration';

@Component({
	selector: 'authentication-layout',
	templateUrl: './authentication-layout.component.html',
	imports: [NgOptimizedImage, RouterOutlet]
})
export class AuthenticationLayoutComponent {
	private config = inject(AppConfiguration);

	assetsPath = '';

	season = seasonClass()

	constructor() {
		const config = this.config;

		this.assetsPath = config.appRootUrl;
	}
}
